module.exports = __webpack_public_path__ + "img/document_color.63be879a.svg";